import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateGroupFooter = (props) => {
  const { mykey } = props.group_data;
  // const group_count = props.group_count ?? 0;
  const group_label = props.group_label ?? "";
  const total_quantity = props.total_quantity ?? 0;
  const sub_total = props.sub_total ?? 0;
  const grand_total = props.grand_total ?? 0;
  const discount = sub_total - grand_total;

  const numberFormat = (number) => {
    // not currency
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  return (
    <tr
      key={`${mykey}-group-footer-${props.group_label}`}
      className={`row-start-start text-sm text-slate-700`}
    >
      <td
        className={`row-start-start  flex-grow border-zinc-300 border border-t-0  px-2 pt-3 pb-3 font-semibold pl-14 gap-10`}
      >
        <span> {group_label}</span>
      </td>

      <td
        className={`${settings["total_quantity"].layout} ${settings["total_quantity"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-3 pb-3 font-bold`}
      >
        {numberFormat(total_quantity)}
      </td>

      <td
        className={`${settings["product_price"].layout} ${settings["product_price"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-3 pb-3 font-bold`}
      >
        -
      </td>

      <td
        className={`${settings["sub_total"].layout} ${settings["sub_total"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-3 pb-3 font-bold`}
      >
        {numberFormat(sub_total)}
      </td>

      <td
        className={`${settings["discount"].layout} ${settings["discount"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-3 pb-3 font-bold`}
      >
        {numberFormat(discount)}
      </td>

      <td
        className={`${settings["grand_total"].layout} ${settings["grand_total"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-3 pb-3 font-bold`}
      >
        {numberFormat(grand_total)}
      </td>
    </tr>
  );
};

export default ReportTemplateGroupFooter;
